export default __webpack_public_path__ + "static/media/14.09cd24d9.png";